module.exports = __webpack_public_path__ + "img/logo_nav.96476f9d.svg";